// @flow

import React from 'react';
import StyledHeader, { Button, Title } from './modalHeader.styled';

type Props = {|
  title: ?string,
  onClose: ?Function,
|};

const ModalHeader = ({ title, onClose }: Props) => (
  <StyledHeader>
    {title && (
      <Title>
        {title}
      </Title>
    )}
    {onClose && (
      <Button onClick={onClose}>
        sluiten
        {' '}
        <i className="icon-cross" />
      </Button>
    )}
  </StyledHeader>
);

export default ModalHeader;
